// @ts-nocheck
import React, { useState, useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EyeIconSVG } from './assets/eye.svg';
import Input from '../input/Input';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

const useStyles = makeStyles((theme: ITheme) => ({
  toggleIcon: ({ passwordVisible, inputValue }) => {
    return {
      '& path': {
        fill: inputValue
          ? passwordVisible
            ? colors.gainsboro
            : colors.darkestGray
          : colors.lightGray,
      },
    };
  },
}));

const FormPasswordInput = (props: {
  [x: string]: any;
  id: any;
  name: any;
  required: any;
  minLength: any;
  disabled: any;
  validate: any;
}) => {
  const { id, name, required, minLength, disabled, validate, ...rest } = props;

  const [passwordVisible, setPasswordVisible] = useState(false);
  const { watch } = useFormContext();
  const inputValue = watch(name);
  const inputType = passwordVisible ? 'text' : 'password';

  const classes = useStyles({
    passwordVisible,
    inputValue,
  });

  const { t } = useTranslation();
  const { errors, register } = useFormContext();

  const generateValidators = useCallback(() => {
    const validators = { required: '' };
    if (required) {
      validators.required = t('v2.global.label_helperText_mandatoryField');
    }
    if (minLength) {
      validators.minLength = minLength;
    }
    if (validate) {
      validators.validate = validate;
    }
    return validators;
  }, [required, minLength, validate, t]);

  return (
    <Input
      id={id}
      type={inputType}
      name={name}
      error={errors[name]}
      ref={register(generateValidators())}
      icon={
        <Box
          component={IconButton}
          size="small"
          mt={1}
          mr={1.5}
          ml={1.5}
          onClick={() =>
            setPasswordVisible((passwordVisible) => !passwordVisible)
          }
          disabled={!inputValue || disabled}
          aria-label={t('FormInput.showPassword')}
        >
          <EyeIconSVG className={classes.toggleIcon} />
        </Box>
      }
      required={required}
      {...rest}
    />
  );
};

FormPasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.shape({
    value: PropTypes.number,
    message: PropTypes.string,
  }),
  validate: PropTypes.func,
};

FormPasswordInput.defaultProps = {
  disabled: false,
  label: '',
  placeholder: '',
  required: false,
  minLength: null,
  validate: null,
};

export default FormPasswordInput;
